import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: none;
  position: fixed;
  left: ${(p) => p.theme.spacing(9)};
  background: ${(p) => p.theme.palette.primary[500]};
  color: ${(p) => p.theme.palette.common.white};
  border-radius: ${(p) => p.theme.spacing(1)};
  padding: ${(p) => p.theme.spacing(1)};
  font-size: ${(p) => p.theme.typography.caption.fontSize};
  opacity: 0;
  transition: all 0.1s ease-in-out;
`;
